import { ILoginTranslation } from 'pages/Login';

export const loginPageTranslations: ILoginTranslation = {
  loginTitle: 'Sign in to your account',
  usernameLabel: 'Username',
  passwordLabel: 'Password',
  loginButtonText: 'Login',
  signupButtonText: 'Sign Up',
};
